<xi-generic-modal
  [canBackdropClose]="false"
  maxWidth="430px"
  [isVisible]="true"
  (onClose)="cancel()"
>
  <div *transloco="let t; read: 'share-dashboard'" slot="children">
    <h2 class="xi-modal__title">{{ t('title') }}</h2>

    <div class="xi-modal__content">
      @if (!linkGenerated) {
        <div class="dropdown-div">
          <xi-dropdown
            select="single"
            [label]="t('share-expiration')"
            [data]="dropdownOptions"
            [stretch]="true"
            [(ngModel)]="shareValue"
          ></xi-dropdown>
        </div>
      } @else {
        <p class="kxi-text-normal">{{ t('dashboard-link-copied') }}</p>
        <p class="kxi-text-normal">{{ t('use-keys-to-share') }}</p>
      }
    </div>

    @if (!linkGenerated) {
      <div class="xi-modal__actions">
        <xi-default-button
          [text]="t('cancel')"
          fill="text"
          (onClick)="cancel()"
        ></xi-default-button>
        <div class="xi-loader-button-container">
          <xi-default-button
            [text]="t('confirm')"
            (onClick)="generate()"
            [disabled]="isGenerating"
          ></xi-default-button>
          @if (isGenerating) {
            <div class="xi-loader-container__inline-overlay">
              <xi-animation
                [height]="75"
                [width]="75"
                [loop]="true"
                animation="cx_loader"
              ></xi-animation>
            </div>
          }
        </div>
      </div>
    }
    @if (linkGenerated) {
      <div class="xi-modal__actions">
        <xi-default-button [text]="t('ok')" (onClick)="cancel()"></xi-default-button>
      </div>
    }
  </div>
</xi-generic-modal>
